import React from "react";
import "./Tokenomics.css";
import chart from "../Assets/pikachuLogo-removebg-preview.png";
import tkn_bg from "../Assets/pikachuLogo-removebg-preview.png";

export default function Tokenomics() {
  return (
    <div className="main_token_nomics" id="Tokenomics">
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-md-6">
            <div className="tokeno_mics_content">
              <h1 className="inter_font fw-semibold">
                <span className="grd_text headingFonts">PIKU Tokenomics</span>
              </h1>
              <p className="inter_font gr_text text-dark">
                With a fixed supply of 1 billion PIKU tokens, we’re bringing
                scarcity and value back to meme coins.
              </p>
            </div>
          </div>
        </div>
        <div className="row position-relative align-items-center justify-content-between">
          <img src={tkn_bg} className="tkn_bg" alt="" />
          <div
            className="col-md-5"
            style={{ justifyContent: "center", display: "flex" }}
          >
            <img
              src={chart}
              className=""
              style={{ zIndex: "9999 !important", width: "85% !important" }}
              alt=""
            />
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th className="text-left">Allocation Details</th>
                    <th>% Allocation</th>
                    <th>Tokens</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span
                        className="dot"
                        style={{ backgroundColor: "rgb(244, 194, 54)" }}
                      ></span>{" "}
                      Presale Allocation
                    </td>
                    <td>40%</td>
                    <td>400,000,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        className="dot"
                        style={{ backgroundColor: "rgb(187, 149, 42)" }}
                      ></span>{" "}
                      Liquidity Pool
                    </td>
                    <td>30%</td>
                    <td>300,000,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        className="dot"
                        style={{ backgroundColor: "rgb(120, 229, 226)" }}
                      ></span>{" "}
                      Staking Rewards
                    </td>
                    <td>20%</td>
                    <td>200,000,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        className="dot"
                        style={{ backgroundColor: "rgb(42, 167, 163)" }}
                      ></span>{" "}
                      Marketing Fund
                    </td>
                    <td>7%</td>
                    <td>70,000,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        className="dot"
                        style={{ backgroundColor: "rgb(42, 167, 163)" }}
                      ></span>{" "}
                      Team Reserve
                    </td>
                    <td>3%</td>
                    <td>30,000,000</td>
                  </tr>
                </tbody>
              </table>
              <p className="mt-3">
                Note: PIKU isn’t just another coin. It’s the meme market’s next
                evolution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
